import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ISODate } from 'ha/helpers/hadate/types';
import { APIV2_URL } from './constants';

interface Query {
  rangeFrom?: ISODate;
  rangeTo?: ISODate;
}

interface ListingExclusionResource {
  from: string;
  to: string;
  reason: string;
  source: string;
  isPartial: boolean;
  conversationId: number;
}

interface ListingExclusionsResource {
  rangeFrom: string;
  rangeTo: string;
  dates: ListingExclusionResource[];
}

export default (makeCall: MakeCall) => (
  listingId: number,
  { rangeFrom, rangeTo }: Query = {},
) =>
  makeCall<ListingExclusionsResource>(
    'GET',
    `${APIV2_URL}/listing/${listingId}/exclusions`,
    {
      query: { rangeFrom, rangeTo },
    },
  );
